// ** Initial State
const initialState = {
  allData: [],
  data: null,
  abandonedDataWithPagintion: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true,
  delete: null
}

const abandoned = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }

    case 'GET_USER_DATA':
        return { ...state, data: action.data }

  case 'TRUNCATE_USER_DATA':
        return { ...state, data: null }
  case 'GET_ALL_ABANDONED_WITH_PAGINATION':
        return { ...state, abandonedDataWithPagintion: action.data, pageLoader: false }
  case 'PAGE_LOADER':
        return { ...state, pageLoader: action.data }
  case 'DELETE_ABANDONED_LOG':
        return { ...state, delete: action.data }
    default:
      return { ...state }
  }
}
export default abandoned
